import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function AboutPage() {
  const teamMembers = [{
    name: 'Drew Rayman',
    title: 'CEO, Co-founder',
    bio: 'Drew founded and scaled multiple digital agencies, including Tenthwave (acquired by Accenture Interactive). He brings expertise in digital transformation and leading teams that deliver results.',
    image: 'https://cdn.magicpatterns.com/uploads/swZrypSL1AzbganHY8CbtK/drewrayman.jpg'
  }, {
    name: 'Neil Chinai',
    title: 'Co-founder',
    bio: 'Neil architects enterprise technology systems that handle massive scale. His focus on infrastructure reliability helps organizations build secure platforms that support millions of users.',
    image: 'https://cdn.magicpatterns.com/uploads/v5CgusGinMq4tZ3oeRKnbD/neilchinai.jpg'
  }, {
    name: 'Roseann Palmieri',
    title: 'Board Member',
    bio: 'Roseann provides strategic counsel on navigating regulatory environments and implementing governance frameworks. Her expertise helps organizations balance innovation with compliance requirements.',
    image: 'https://cdn.magicpatterns.com/uploads/gJZPcKZzJxjanPPK7YmjMv/roseannpalmeiri.jpg'
  }, {
    name: 'Alex Ruiz',
    title: 'Workflow Strategist',
    bio: 'Alex co-founded ART X MACHINA, an AI consultancy. He previously worked at Accenture and brings expertise in workflow optimization and AI adoption, empowering teams to work faster and more effectively.',
    image: 'https://cdn.magicpatterns.com/uploads/mEcf9twAf5dJ4raxT9AZES/alex_ruiz.jpg'
  }, {
    name: 'Mike Mazar',
    title: 'Context Guardrail Architect',
    bio: 'Mike co-founded ART X MACHINA, an AI consultancy. He applies design thinking to create AI governance frameworks. He brings expertise in translating complex requirements into intuitive structures that guide AI behavior.',
    image: 'https://cdn.magicpatterns.com/uploads/dKdGwKSqDgkynYCBWYYk5y/mikemazar.png'
  }, {
    name: 'Whit Thiele',
    title: 'CTO',
    bio: 'Whit brings decades of experience spanning enterprise systems, PaaS/SaaS architecture, telecommunications, and big data, with expertise in technology assessments and diligence.',
    image: 'https://cdn.magicpatterns.com/uploads/1qDe2Eq5QGhNAXh67mzVuW/whittheile.jpg'
  }, {
    name: 'Andy Brown',
    title: 'Advisor',
    bio: "Andy serves on the boards of Zscaler and Pure Storage, and co-founded Sand Hill East. He's the architect of modern fintech infrastructure, having served in leadership roles at many Fortune 100 companies.",
    image: 'https://cdn.magicpatterns.com/uploads/gGf4w2YqqUfDGdR5tAW6Cm/andybrown.jpg'
  }, {
    name: 'Philip Brittan',
    title: 'Advisor',
    bio: "Philip is CEO of Bloomfire and served as VP of Google Workspace. He's a 4x founder who has raised over $100M in funding and managed global teams with multi-billion dollar budgets, redefining enterprise platforms at scale.",
    image: 'https://cdn.magicpatterns.com/uploads/9s85jxMmN2uJCzprvcX5ZN/philipbrittan.jpg'
  }, {
    name: 'Lisa Nelson',
    title: 'Advisor',
    bio: 'Lisa brings board-level expertise in AI safety, ethics, and corporate governance. She has led global transformations and post-merger integrations, helping companies balance innovation with disciplined execution and risk mitigation.',
    image: 'https://cdn.magicpatterns.com/uploads/sZYhD38hcR7t4is1nbP1fF/lisanelson.jpg'
  }, {
    name: 'Andy Honess',
    title: 'Advisor',
    bio: 'Andy guided Qlik from early stage to a successful Nasdaq IPO. He created the Business Alignment Management methodology for scaling startups and held senior roles at leading enterprise software companies.',
    image: 'https://cdn.magicpatterns.com/uploads/kVAfVcG4iNyrAWDw2d1yt8/andyhoness.jpg'
  }, {
    name: 'Enno Vandermeer',
    title: 'Advisor',
    bio: "Enno founded Roon Labs and serves as VP at Harman. He's a product visionary who defined the standard for high-fidelity data experiences, building technologies that connect people to music with uncompromising quality and intuitive design.",
    image: 'https://cdn.magicpatterns.com/uploads/9kVxNmjnpEVCqjHQrwNVqR/ennovandermmer.jpg'
  }, {
    name: 'Allen Blum',
    title: 'Advisor',
    bio: "Allen brings over 40 years of media expertise spanning linear and digital platforms. He's known as a connector and deal maker with deep relationships across ad sales, advanced platforms, programming, and technology.",
    image: 'https://cdn.magicpatterns.com/uploads/ke3Qqqec4MEqJx9EDepK9Z/allenblum.jpg'
  }, {
    name: 'Mordy Golding',
    title: 'Advisor',
    bio: 'Mordy helps business leaders navigate AI adoption with 25+ years in tech. He led digital transformation at Adobe, drove online learning at Lynda.com and LinkedIn, and built practical applications used by millions.',
    image: 'https://cdn.magicpatterns.com/uploads/4kfxdJzXMA3dWSeha7XzpL/mordygolding.jpg'
  }, {
    name: 'David Berkowitz',
    title: 'Advisor',
    bio: "David founded AI Marketers Guild and Serial Marketers (acquired) and leads High Caliber AI. He's recognized as one of the most respected voices in AI marketing, building communities and strategies that help B2B tech companies harness AI.",
    image: 'https://cdn.magicpatterns.com/uploads/8xoLLifAvdqP1xdWGwnKX3/davidberkowitz.jpg'
  }, {
    name: 'Jonathan Ellner',
    title: 'Business Development',
    bio: 'Jonathan brings expertise in brand storytelling, building high-performing creative teams, and distilling complex ideas into engaging content that aligns with strategic objectives.',
    image: 'https://cdn.magicpatterns.com/uploads/6Ub5H4ab3zmJcGLR9tb6ok/jonathanellner.jpg'
  }, {
    name: 'Michael Szot',
    title: 'Business Development',
    bio: 'Michael brings decades of experience facilitating executive-level relationships in Life Sciences, Healthcare, and Regulated industry segments, helping corporations accelerate results within competitive and highly regulated markets.',
    image: 'https://cdn.magicpatterns.com/uploads/tRoe2CRZophmtCc7p6JdK8/michaelszot.jpg'
  }];
  return <div className="min-h-screen w-full bg-black selection:bg-[#0066FF] selection:text-white" data-id="element-1300">
      {/* Header - White background */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-1301">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-1302">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-1303">
            <Link to="/" data-id="element-1304">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-1305" />
            </Link>
            <Navigation data-id="element-1306" />
          </div>
        </div>
      </header>

      <main className="pt-20" data-id="element-1307">
        {/* Hero Section */}
        <section className="py-16 px-6 md:px-12 lg:px-24" data-id="element-1308">
          <div className="max-w-4xl mx-auto" data-id="element-1309">
            <div className="inline-flex items-center px-3 py-1 rounded-full border border-white/20 bg-white/5 mb-8 w-fit" data-id="element-1310">
              <span className="text-xs font-medium text-white uppercase tracking-widest font-sans" data-id="element-1311">
                ABOUT US
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-12 leading-tight" data-id="element-1312">
              "Why are sales down in the Northeast?"
            </h1>

            <div className="space-y-6 text-white text-xl leading-relaxed" data-id="element-1313">
              <p data-id="element-1314">Seems straightforward. It's not.</p>
              <p data-id="element-1315">
                The first time we asked ChatGPT that question, it answered like
                an over-eager intern—confidently wrong. It didn't understand
                what "Northeast" means to our company, what we're selling, who
                was asking, the timeframe, our definition of "down," or what
                external factors might be affecting the business. It was
                guessing based on patterns, not our reality.
              </p>
              <p data-id="element-1316">
                We tried everything. RAG gave us data retrieval, not reasoning.
                Knowledge graphs organized information but couldn't make
                decisions. Semantic search found relevant content but missed the
                judgment calls that actually matter.
              </p>
              <p data-id="element-1317">
                Frontier models have a fatal flaw: they need rules but ignore
                them under complexity. Give them 100 compliance
                boundaries—they'll follow maybe 20. They run on vibes, not
                rules.
              </p>
              <p data-id="element-1318">
                We needed something that didn't exist—a layer with complete
                situational awareness that injects the right context
                automatically and enforces what actually matters. A way to make
                AI behave within your boundaries, not guess at them.
              </p>
              <p data-id="element-1319">So we built it.</p>

              <p className="text-[#FFE066] font-medium text-2xl" data-id="element-1320">
                Because, as always, better questions lead to better answers.
              </p>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="py-16 px-6 md:px-12 lg:px-24" data-id="element-1321">
          <div className="max-w-4xl mx-auto border-t border-white/30 pt-16" data-id="element-1322">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-12" data-id="element-1323">
              Humans in-the-Loop:
            </h2>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-10" data-id="element-1324">
              {teamMembers.map((member, index) => <div key={index} className="flex flex-col" data-id="element-1325">
                  {/* Image or placeholder */}
                  {member.image ? <img src={member.image} alt={member.name} className="w-24 h-24 object-cover rounded-sm mb-3" data-id="element-1326" /> : <div className="w-24 h-24 bg-white rounded-sm mb-3 flex items-center justify-center" data-id="element-1327">
                      <span className="text-gray-400 text-xs font-medium" data-id="element-1328">
                        IMAGE
                      </span>
                    </div>}

                  {/* Name in yellow */}
                  <h3 className="text-[#FFE066] font-bold text-sm mb-1" data-id="element-1329">
                    {member.name}
                  </h3>

                  {/* Title in italic white */}
                  <p className="text-white font-medium italic text-xs mb-2" data-id="element-1330">
                    {member.title}
                  </p>

                  {/* Bio */}
                  <p className="text-white font-medium text-xs leading-relaxed" data-id="element-1331">
                    {member.bio}
                  </p>
                </div>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1332" />
    </div>;
}